"use client"
import { type ICustomImage } from "@filmweb/sanity-types";
import { useMediaQuery } from "@react-hooks-library/core";
import CmsImage from 'src/components/images/CmsImage';
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import Image from 'src/components/images/Image';
import { ImageVersion } from 'src/lib/movieinfo/movieinfotypes';
import styles from './MoviePoster.module.css';

//#region [Props]
type MoviePosterProps = {
	cmsPoster?: ICustomImage;
	filminfoPosters?: ImageVersion[] | null;
	filmTitle: string;
	sanityPosterUrl?: string | null;
	isStreamingContext: boolean;
};
//#endregion

//#region [Component]
export default function MoviePoster({ cmsPoster, filminfoPosters, filmTitle, isStreamingContext, sanityPosterUrl }: MoviePosterProps) {
	const isMobile = useMediaQuery("(max-width: 549px)")
	if( isMobile ) {
		return null;
	}

	return <div className={styles.posterContainer}>
		{isStreamingContext && sanityPosterUrl && <CmsImageForUrl className={styles.sanityPoster} imageUrl={sanityPosterUrl} alt={`Plakat for '${filmTitle}'`} unoptimized width={333}/>}
		{!(isStreamingContext && sanityPosterUrl) && cmsPoster && <CmsImage className={styles.cmsPoster} alt={`Plakat for '${filmTitle}'`} image={cmsPoster} width={333} unoptimized/>}
		{isStreamingContext && !sanityPosterUrl && !cmsPoster && (filminfoPosters?.length ?? 0) > 0 && <Image className={styles.filminfoPoster} image={filminfoPosters!} alt={`Plakat for '${filmTitle}'`} sizes="333px"/>}
	</div>;
}
//#endregion
